
import { computed, defineComponent, onBeforeMount, reactive, ref } from 'vue';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { Tab, Modal, Slide } from './components';
// import {
//   openSharePanel,
//   shareLink,
//   AllChanel,
//   ShareChannel,
//   isCommonError,
//   CallErrorType,
// } from '@tencent/vb-app-bridge';
// import { ShareResponse } from '@tencent/vb-app-bridge/lib/src/type/share';
import { i18n, reportStatistics, setShareInfo, shareLink } from '@tencent/vb-web-base';
import { to } from '@tencent/vb-web-base-core';
import { getQuery, parse, getUrl, setQuery } from '@tencent/multi-url';
import { baseMixins } from '@common/mixins/baseMixins';
import { GetLoanConfigList } from '../../core/network/NodeAPI';
import {
  ILoanLeaseItem,
  ILoanLeaseConfig,
  ILoanLeaseItemResp,
  ILoanLeaseConfigResp,
} from '../../core/interface/IModel';
export default defineComponent({
  components: {
    Tab,
    Modal,
    Slide,
  },
  setup() {
    const isApp = window.navigator.userAgent.indexOf('VB') > -1;
    const { tab, id = 'RNPL01' } = getQuery();
    const selectValue = ref('1');
    const isModalShow = ref(false);
    const { setTitle, getLanguage, showModalError, showModal } = baseMixins();
    // 活动页面配置
    const configInfo = reactive<ILoanLeaseConfig>({
      title: '',
      banner: [],
      tab1: [],
      tab2: [],
      slide: [],
      footer: [],
      protocol: [],
    });
    // 多语言设置标题
    const lang = getLanguage();
    const { getT } = i18n;
    // i18n.setLang('en-GB');
    const $t = getT();
    // setTitle($t('先租后付'));

    const options = [
      {
        label: $t('准租客'),
        value: '1',
      },
      {
        label: $t('业主'),
        value: '2',
      },
    ];

    const formatParam = (p: string): ILoanLeaseItem[] => {
      let config: ILoanLeaseItemResp[];
      try {
        config = JSON.parse(p);
      } catch (err) {
        config = [];
      }
      return config
        .map((item) => {
          if (!item.link) {
            // eslint-disable-next-line no-param-reassign
            item.link = item[`link_${lang}`];
          }
          return {
            image: item[lang],
            ...item,
          };
        })
        .filter((item) => {
          if (item.channel === 'other' && isApp) {
            return false;
          }
          if (item.channel === 'app' && !isApp) {
            return false;
          }
          return true;
        });
    };

    const formatTextParam = (p: string): string => {
      let config: ILoanLeaseItemResp[];
      try {
        config = JSON.parse(p);
      } catch (err) {
        config = [];
      }
      return config[0]?.[lang];
    };

    // 获取入口配置
    const getConfigInfo = async () => {
      const [data, err] = await to(GetLoanConfigList<{ content: ILoanLeaseConfigResp[] }>('loan_lease_V2'));
      if (err) {
        showModalError(err.message, err.code);
        return;
      }
      if (data?.content?.length) {
        const config = data.content.find((item) => item.id === id);
        if (config) {
          configInfo.title = formatTextParam(config.title as unknown as string);
          // 设置页面标题
          setTitle(configInfo.title);
          configInfo.banner = formatParam(config.banner as unknown as string);
          configInfo.tab1 = formatParam(config.tab1 as unknown as string);
          configInfo.tab2 = formatParam(config.tab2 as unknown as string);
          configInfo.slide = formatParam(config.slide as unknown as string);
          configInfo.footer = formatParam(config.footer as unknown as string);
          configInfo.protocol = formatParam(config.protocol as unknown as string);
        } else {
          showModalError($t('活动已结束'));
        }
      }
    };

    // const initWxShare = () => {
    //   if (isWeChat) {
    //     const { title, link, thumbPath, content } = getShareInfo();
    //     console.log({ content, title, link, thumbPath });
    //     wxBridge.setShareInfo({
    //       title,
    //       desc: content,
    //       link,
    //       imgUrl: thumbPath,
    //     });
    //   }
    // };

    const initShare = () => {
      const { title, link, thumbPath, content } = getShareInfo();
      setShareInfo({
        linkContent: link,
        wxDesc: content,
        wxTitle: title,
        link,
        wxThumbPath: thumbPath,
      });
    };

    // 初始化赋值
    const init = () => {
      if (tab) {
        selectValue.value = tab as string;
      }
      // initWxShare();
      initShare();
    };

    const slideTop = computed(() => configInfo.tab1.filter((item) => item?.position === 'top'));
    const slideBottom = computed(() => configInfo.tab1.filter((item) => item?.position === 'bottom'));

    const handleClick = async (item: ILoanLeaseItem) => {
      if (item.link) {
        let { link } = item;
        if (item.key) {
          await reportStatistics({ evtName: item.key });
        }
        const parseLink = parse(item.link);
        const parseUrl = parse();
        if (parseLink.hash === parseUrl.hash && parseLink.query.tab === parseUrl.query.tab) {
          window.scrollTo(0, 0);
          selectValue.value = parseLink.query.tab as string;
        } else {
          const url = setQuery(item.link, 'lang', lang);
          console.log(url);
          link = url;
          if (link.includes('https://wa.me') || link.includes('https://api.whatsapp.com')) {
            if (isApp) {
              return;
            }
            const res = await showModal($t('您将离开本网站，并对外连接至第三方网站'), $t('您将离开本网站'), $t('取消'));
            if (res === 'cancel') {
              return;
            }
          }
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          window.top!.location.href = link;
        }
      }
      if (item.type === 'popup') {
        if (item.key) {
          await reportStatistics({ evtName: item.key });
        }
        isModalShow.value = true;
      }
    };

    const getShareInfo = () => {
      let link = setQuery(getUrl(), 'tab', selectValue.value);
      link = setQuery(link, 'lang', lang);
      const desc = selectValue.value === '1' ? '租客版' : '业主版';
      const title = $t('贷款优惠');
      // selectValue.value === '1'
      //   ? $t('贷款优惠')
      //   : $t('教您精明放租免租霸，享高达HKD1,000现金及其他奖赏！');
      const content = $t('点击以了解详情! 受条款及细则约束。借定唔借 ? 还得到先好借 !');
      // selectValue.value === '1'
      //   ? $t(
      //       '以我们灵活的循环贷款预缴1年租金助你向业主争取租金折扣! 先入住, 后分期! 租金平了, 可以住更大更好! 连同「快闪优惠」，甚至可抵销所有利息支出之余更有赚, 真正租屋悭到尽！您怎能错过？',
      //     )
      //   : $t(
      //       '「先租后付」让租客一笔过预缴全年租金, 兼网上转账确保即时收款，更免除欠租风险及支票无效等痛点。只需开户即享奖赏高达HKD1,000、存款专属利率、及购买实惠家俬低至9折！您怎能错过？',
      //     );
      /* eslint-disable */
      const thumbPath = require('@/assets/images/lease/sharenew.png');
      return {
        thumbPath: `https:${thumbPath}`,
        desc,
        title,
        content,
        link,
      };
    };

    const tabClick = (val: string) => {
      initShare();
    };

    // 分享活动
    const handleShare = async () => {
      const { desc } = getShareInfo();
      reportStatistics({
        evtName: `tab${selectValue.value}share`,
        desc: `先租后付活动${desc}分享按钮点击`,
      });
      shareLink();
      // try {
      //   const allChanels: AllChanel[] = isIos
      //     ? [
      //         ShareChannel.FACEBOOK,
      //         ShareChannel.WECHAT_MESSAGE,
      //         ShareChannel.WECHAT_MOMENT,
      //         ShareChannel.MESSENGER,
      //         ShareChannel.MORE,
      //       ]
      //     : [
      //         ShareChannel.WHATSAPP,
      //         ShareChannel.FACEBOOK,
      //         ShareChannel.WECHAT_MESSAGE,
      //         ShareChannel.WECHAT_MOMENT,
      //         ShareChannel.MESSENGER,
      //         ShareChannel.MORE,
      //       ];
      //   const channel = await openSharePanel(allChanels);
      //   if (channel === ShareChannel.UNKNOWN) {
      //     // 需要处理未知的渠道
      //     return;
      //   }
      //   /* eslint-disable */
      //   const result = await shareLink(channel, {
      //     thumbPath,
      //     title,
      //     link,
      //     content,
      //   });
      //   if (result.result === '0') {
      //     reportStatistics({
      //       evtName: `tab${selectValue.value}ShareSuccess`,
      //       desc: `先租后付活动${desc}分享成功`,
      //     });
      //   }
      // } catch (err) {
      //   if (isCommonError(err)) {
      //     if (err.type === CallErrorType.OTHER_ERROR) {
      //       const { msg, result } = err.result as ShareResponse;
      //       if (result !== '0') {
      //         reportStatistics({
      //           evtName: `tab${selectValue.value}ShareError`,
      //           desc: `先租后付活动${desc}分享失败`,
      //         });
      //       }
      //       if (result === '-2') {
      //         showModalError(msg);
      //       }
      //       console.log(msg);
      //       // 0    分享成功
      //       // -1    分享失败
      //       // -2    分享渠道对应app没安装
      //       // -3    用户主动取消
      //       // -4    相册权限未经用户授权    涉及图片操作时需要该权限
      //     }
      //   }
      // }
    };

    onBeforeMount(async () => {
      spin.show();
      init();
      await getConfigInfo();
      spin.hide();
    });
    return {
      tabClick,
      isApp,
      options,
      selectValue,
      isModalShow,
      configInfo,
      slideTop,
      slideBottom,
      handleClick,
      handleShare,
    };
  },
});
